module.exports = __webpack_public_path__ + "img/4.600a7944.jpg";